import { render } from "./AlertError.vue?vue&type=template&id=9d665cfe"
import script from "./AlertError.vue?vue&type=script&lang=js"
export * from "./AlertError.vue?vue&type=script&lang=js"
script.render = render

export default script